/**
 * Eligibility rules for an inspection equipment document (T20-136449). These checks only give the
 * author fast feedback in the picker; they are not a security boundary — the content of a storage
 * upload is controlled by whoever holds the signed URL, so the backend has to verify it on attach.
 */
export const EQUIPMENT_DOCUMENT_FILE_CONSTRAINTS = {
  mimeType: 'application/pdf',
  extension: '.pdf',
  maxSizeBytes: 10_000_000,
  /** Every PDF starts with this header; a renamed non-PDF file does not. */
  signature: '%PDF-',
};
